import publicIp from 'public-ip';

let usersIp = null;

// Attempt to grab the users IP address, used to send to HubSpot
publicIp.v4().then((ip) => {
  usersIp = ip;
});

const getUsersIp = () => usersIp;

export { getUsersIp };
